import { useAuth } from "../../../context/AuthContext/AuthContext";
import "./AuthButton.css";

function LogoutButton() {
  const { logout } = useAuth();
  return (
    <button className="auth-button" onClick={logout}>
      Log Out
    </button>
  );
}

export default LogoutButton;
